import React, { useEffect, useState } from "react";
import school from "../../../assets/img/school/newSchool.png";
import school1 from "../../../assets/img/school/web logo@4x.png";
import school2 from "../../../assets/img/admission/admission_1.jpg";
import school3 from "../../../assets/img/admission/admission_2.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import Meta from "../../meta/Meta";
import { Link, useParams } from "react-router-dom";
import PopularEvents from "./PopularEvents";

const images = [school, school1, school2, school3];

const BlogDetail = () => {
  const { id } = useParams();
  const pageDescription =
    "Experience the vibrancy of regular events at Al-Maghrib International School. Explore our students' diverse activities, both on and off-campus, where they learn, unwind, and build lasting memories. Discover a dynamic blend of education and enjoyment, fostering holistic growth and enriching experiences.";
  let pageImage = "https://i.ibb.co/gwkTRWk/new-School.png";
  const pageUrl = `https://almaghribschool.com/events/${id}`;
  let title = "News and Events | Al-Maghrib";

  const [singleEvent, setSingleEvent] = useState({});
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "News and Events | Al-Maghrib";

    fetch(`https://al-maghrib-server.vercel.app/magazine/single-magazine/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setSingleEvent(data.singleMagazine);
        document.title = `${data.singleMagazine.headline} | Al-Maghrib`;
        pageImage = `${data.singleMagazine.imagesInfo[0]?.url}`;
      });
  }, [id]);

  title = `${
    singleEvent.headline ? singleEvent?.headline : "News and Events"
  } | Al-Maghrib`;

  const formattedDescription1 = singleEvent?.description1
    ?.split("\n")
    .map((line, index) => <p key={index}>{line}</p>);
  const finalDescription1 = formattedDescription1?.reduce((prev, curr) => [
    prev,
    <br />,
    curr,
  ]);

  const formattedDescription2 = singleEvent?.description2
    ?.split("\n")
    .map((line, index) => <p key={index}>{line}</p>);
  const finalDescription2 = formattedDescription2?.reduce((prev, curr) => [
    prev,
    <br />,
    curr,
  ]);
  return (
    <>
      <Meta
        pageTitle={title}
        pageDescription={pageDescription}
        pageImage={pageImage}
        pageUrl={pageUrl}
      />
      <div className="max-w-[90%] md:max-w-[90%] lg:max-w-[80%] mx-auto mt-8">
        {/* Top Image Slider Section */}
        <div className="w-full h-[300px] md:h-[450px] overflow-hidden rounded-lg">
          <Swiper
            navigation
            modules={[Navigation, Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            className="w-full h-full"
          >
            {singleEvent && singleEvent.imagesInfo && singleEvent.imagesInfo.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image.url}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Main Content Section */}
        <div className="flex flex-col md:flex-row gap-8 mt-8">
          {/* Left Column */}
          <div className="md:w-2/3">
            <article>
              <h1 className="text-3xl font-bold mb-4">
                {singleEvent.headline}
              </h1>
              <div className="mb-4">
                {singleEvent.date} &middot; {singleEvent.readTime} min read
              </div>
              {/* Quote Section */}
              {
                singleEvent.quote && <div className="bg-blue-100 rounded-lg p-6 my-6">
                <blockquote className="text-lg font-semibold italic text-blue-800">
                  `  “${singleEvent.quote}”`
                </blockquote>
                <cite className="block text-right mt-4 text-gray-500">
                  - Antonio Domacio
                </cite>
              </div>
              }
              <p className="text-gray-600 mb-6">
                {finalDescription1 && finalDescription1}
              </p>
              <h2 className="text-2xl font-semibold mt-6 mb-4 border p-2 text-blue-600">
                Admission is going on Al-Maghrib International School. Visit our campus to know more.
              </h2>
              <p className="text-gray-600 mb-6">
                {finalDescription2 && finalDescription2}
              </p>
              <h2 className="text-2xl font-semibold mt-6 mb-4">
                What is it with your ideas?
              </h2>
              <p className="text-gray-600 mb-6">
               At Al-Maghrib, we value your feedback. If you want to give us any feedback, <Link to="/contact-us" className="text-blue-600 hover:underline">contact us</Link> or visit our campus.
              </p>
            </article>

            {/* Tags and Share Section */}
            <div className="flex flex-wrap items-center gap-4 my-6">
              <div className="flex gap-2">
                <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm">
                  Al-Maghrib
                </span>
                <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm">
                  Development
                </span>
                <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm">
                  Info
                </span>
              </div>
              <div className="flex gap-2 ml-auto">
                <button className="text-blue-600 hover:underline">
                  Share on Facebook
                </button>
                <button className="text-blue-600 hover:underline">
                  Share on Twitter
                </button>
                <button className="text-blue-600 hover:underline">
                  Share on LinkedIn
                </button>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <aside className="md:w-1/3 space-y-6">
            {/* Newsletter Subscription Box */}
          
            <div className="bg-blue-500 text-white p-6 rounded-lg">
              <h2 className="text-xl font-bold mb-4">Join our newsletter!</h2>
              <p className="text-sm mb-4">
                <a href="https://almaghribschool.com/newsletter" target="_blank" >Click here to visit our biannual magazine section.</a>
              </p>
              {/* <input
                type="email"
                placeholder="Your email address"
                className="w-full px-4 py-2 mb-4 rounded-lg focus:outline-none"
              />
              <button className="w-full bg-white text-blue-500 py-2 rounded-lg font-semibold">
                Subscribe Now
              </button>
              <p className="text-xs text-center mt-2">
                Don’t worry, we don’t spam
              </p> */}
            </div>

            {/* Popular Articles Section */}
            <PopularEvents currentId={id} />

            {/* Banner Ad Section */}
            <div className="w-full h-40 rounded-lg flex items-center justify-center ">
              {/* <span className="text-gray-500 ">Our Curriculum</span> */}
              <img
                  src={school}
                  alt={`Slide`}
                  className="w-full h-full object-contain mb-5"
                  loading="lazy"
                />
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
